export const InitialWish = {
    wish: ''
};